import * as React from 'react';
export var AnimationDirection;
(function(AnimationDirection) {
    AnimationDirection[AnimationDirection[/**
   * Grid will transition out and in horizontally
   */ "Horizontal"] = 0] = "Horizontal";
    AnimationDirection[AnimationDirection[/**
   * Grid will transition out and in vertically
   */ "Vertical"] = 1] = "Vertical";
})(AnimationDirection || (AnimationDirection = {}));
